const loaders: Record<string, () => Promise<unknown>> = {
  home: () => import('./views/YomiriHomeView.tsx'),
  explore: () => import('./views/YomiriMangaEntry.tsx'),
  sources: () => import('./views/YomiriSourcesView.tsx'),
  live: () => import('./views/YomiriLiveView.tsx'),
  anime: () => import('./views/YomiriAnimeEntry.tsx'),
  library: () => import('./views/YomiriLibraryView.tsx'),
  downloads: () => import('./views/YomiriLibraryView.tsx'),
  history: () => import('./views/YomiriHistoryView.tsx'),
  updates: () => import('./views/YomiriUpdatesView.tsx'),
  more: () => import('./views/YomiriSettingsView.tsx'),
};
const pending = new Map<string, Promise<unknown>>();
/** Warm code on navigation intent without mounting views or querying sources. */
export function preloadView(view: string): void {
  if (!loaders[view] || pending.has(view)) return;
  const job = loaders[view]().catch(() => { pending.delete(view); });
  pending.set(view, job);
}
